import React, { useEffect, useRef, useState } from "react";

export default function TextCollapse({ text }) {
  const [show, setShow] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const ref = useRef();

  function checkOverflow() {
    if (!ref.current) return false;

    const el = ref.current;
    return el.offsetHeight < el.scrollHeight;
  }

  useEffect(() => {
    let handleResize;

    if (ref.current) {
      handleResize = () => {
        setIsOverflowing(checkOverflow());
      };
      window.addEventListener("resize", handleResize);
      handleResize();
    }
    return () => {
      if (handleResize) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, [ref, text, show]);

  return (
    <div>
      <div
        ref={ref}
        style={{
          overflow: "hidden",
          ...(show ? {} : { height: "1.5em" }),
        }}
      >
        <div>{text}</div>
      </div>
      {(isOverflowing || show) && (
        <button
          type="button"
          className="btn btn-link link-secondary p-0"
          onClick={() => setShow((p) => !p)}
        >
          (show {show ? "less" : "more"})
        </button>
      )}
    </div>
  );
}
